/* Dozele — comportamentele temei: media, derulare pe telefon, calculator, coș pe API-ul Shopify. */
const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const PLAYABLE = !REDUCED;
const phone = () => matchMedia('(max-width: 1080px)').matches;

/* ---------- media ---------- */
/* Video cu transparență: Safari redă doar HEVC cu alfa, Chrome și Firefox doar VP9 cu alfa. Chrome pe Mac pretinde că
   poate HEVC, dar fără alfa, deci alegerea se face după browser, nu după canPlayType. */
const SAFARI = /^((?!chrome|chromium|android|crios|fxios|edg).)*safari/i.test(navigator.userAgent);
function videoSrc(v) { if (SAFARI) return v.dataset.hevc || v.dataset.mp4 || v.dataset.webm || v.dataset.src; return v.dataset.webm || v.dataset.mp4 || v.dataset.src; }
const inViewIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
  const v = e.target;
  if (e.isIntersecting) { if (!v.getAttribute('src')) { const s = videoSrc(v); if (s) v.src = s; } if (PLAYABLE) v.play().catch(() => {}); }
  else v.pause();
}), { threshold: .2 }) : null;
function playInView(root = document) { if (!inViewIO) return; $$('video[data-src], video[data-webm], video[data-mp4], video[data-hevc]', root).forEach(v => inViewIO.observe(v)); }

/* ---------- o singură emergență pe secțiune ---------- */
const revealIO = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } }), { threshold: .2 });
function observeReveals(root = document) { $$('[data-reveal]', root).forEach(el => { if (REDUCED) el.classList.add('in'); else revealIO.observe(el); }); }

/* ---------- rândurile derulate pe orizontală pe telefon ---------- */
/* Sub fiecare rând, o linie care arată cât s-a derulat. Primul rând care intră în ecran se trage o dată spre stânga și
   revine, ca vizitatorul să vadă că mai sunt cadre. O singură dată pe vizită, deloc după ce a derulat singur un rând. */
const SWIPE_ROWS = '.mrow, .closeups, .panels, .strip, .gallery .thumbs, .hub.trei';
let swipeTaught = false;
const swipeIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && e.target._nudge?.()) swipeIO.disconnect(); }), { threshold: .6 }) : null;
function initSwipe(row) {
  if (!row || row._swipe) return; row._swipe = true;
  const bar = document.createElement('div'); bar.className = 'swipe'; bar.setAttribute('aria-hidden', 'true'); bar.innerHTML = '<i></i>';
  row.after(bar); const thumb = bar.firstChild;
  const room = () => row.scrollWidth - row.clientWidth;
  const geo = () => { const share = row.clientWidth / row.scrollWidth; return { share, travel: bar.clientWidth * (1 - share) }; };
  let raf = 0;
  const paint = () => { raf = 0; const m = room(); bar.classList.toggle('off', m < 8); if (m < 8) return; const { share, travel } = geo(); thumb.style.width = `${(share * 100).toFixed(2)}%`; thumb.style.transform = `translateX(${(row.scrollLeft / m * travel).toFixed(1)}px)`; };
  const queue = () => { if (!raf) raf = requestAnimationFrame(paint); };
  row.addEventListener('scroll', () => { if (phone()) swipeTaught = true; queue(); }, { passive: true });
  if ('ResizeObserver' in window) new ResizeObserver(queue).observe(row); else addEventListener('resize', queue);
  paint();
  row._nudge = () => {
    if (swipeTaught || REDUCED || !phone() || row.scrollLeft > 4 || room() < 8) return false;
    swipeTaught = true;
    const d = Math.round(Math.min(64, row.clientWidth * .16)), { travel } = geo(), td = d / room() * travel;
    const go = 'cubic-bezier(.45, 0, .2, 1)', back = 'cubic-bezier(.16, 1, .3, 1)';
    const frames = x => [{ transform: 'translateX(0)', easing: go }, { transform: `translateX(${x}px)`, offset: .38 }, { transform: `translateX(${x}px)`, offset: .5, easing: back }, { transform: 'translateX(0)' }];
    const opts = { duration: 1700, delay: 350 };
    const anims = [...row.children].map(k => k.animate(frames(-d), opts)).concat(thumb.animate(frames(td), opts));
    const stop = () => anims.forEach(a => a.cancel());
    row.addEventListener('touchstart', stop, { once: true, passive: true });
    row.addEventListener('pointerdown', stop, { once: true });
    return true;
  };
  swipeIO?.observe(row);
}

/* ---------- galerie de produs ---------- */
function initGallery(root = document) {
  $$('.gallery', root).forEach(g => {
    if (g.dataset.bound) return; g.dataset.bound = '1';
    const main = $('.main', g), thumbs = $$('.thumbs button', g);
    thumbs.forEach(b => b.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('on')); b.classList.add('on');
      if (b.dataset.video) {
        main.innerHTML = `<video muted loop playsinline autoplay src="${b.dataset.video}" poster="${b.dataset.src}"></video>`;
        if (PLAYABLE) $('video', main).play().catch(() => {});
      } else main.innerHTML = `<img src="${b.dataset.src}" alt="${b.dataset.alt || ''}">`;
      main.classList.toggle('contain', b.dataset.contain === '1');
    }));
  });
}

/* ---------- cantitate ---------- */
/* Dozele se vând la cutie, deci pasul vine din temă (eticheta „cutie-200”). */
function bindQty(root = document) {
  $$('.qty', root).forEach(q => {
    if (q.dataset.bound) return; q.dataset.bound = '1';
    const [m, p] = $$('button', q), inp = $('input', q);
    const step = parseInt(q.dataset.step) || 1, min = parseInt(q.dataset.min) || step;
    const fix = () => { inp.value = Math.max(min, Math.round((parseInt(inp.value) || min) / step) * step); q.dispatchEvent(new CustomEvent('qty', { bubbles: true })); };
    m.onclick = () => { inp.value = (parseInt(inp.value) || min) - step; fix(); };
    p.onclick = () => { inp.value = (parseInt(inp.value) || 0) + step; fix(); };
    inp.addEventListener('change', fix);
  });
}

/* ---------- coș ---------- */
const COS = {
  get drawer() { return $('#drawer'); },
  get sectiune() { return this.drawer?.dataset.section; },
  deschide() { document.body.classList.add('lock'); const d = this.drawer; d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); const bg = $('#drawerBg'); bg.hidden = false; requestAnimationFrame(() => bg.classList.add('on')); },
  inchide() { document.body.classList.remove('lock'); const d = this.drawer; d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); const bg = $('#drawerBg'); bg.classList.remove('on'); setTimeout(() => { if (!d.classList.contains('open')) bg.hidden = true; }, 350); },
  async cerere(url, corp) {
    const r = await fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...corp, sections: this.sectiune, sections_url: location.pathname })
    });
    const date = await r.json();
    if (!r.ok) throw new Error(date.description || date.message || 'cart');
    if (date.sections?.[this.sectiune]) this.deseneaza(date.sections[this.sectiune]);
    return date;
  },
  deseneaza(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const corpNou = $('#cartBody', doc), finalNou = $('.df', doc);
    if (corpNou) $('#cartBody').replaceWith(corpNou);
    if (finalNou) $('.drawer .df').replaceWith(finalNou);
    const n = parseInt(corpNou?.dataset.count || '0');
    $$('#cartCount').forEach(c => { c.textContent = n > 999 ? '999+' : n; c.classList.toggle('has', n > 0); });
    bindQty(this.drawer);
  },
  async adauga(idVariant, cantitate = 1) {
    try { await this.cerere('/cart/add.js', { items: [{ id: Number(idVariant), quantity: cantitate }] }); this.deschide(); }
    catch (e) { const t = $('.foot .tel')?.textContent.trim(); alert(`Nu am putut adăuga produsul. Încearcă din nou${t ? ' sau sună la ' + t : ''}.`); }
  },
  async schimba(cheie, cantitate) { try { await this.cerere('/cart/change.js', { id: cheie, quantity: cantitate }); } catch {} }
};

function bindCos() {
  const drawer = $('#drawer'); if (!drawer) return;
  $('#cartBtn')?.addEventListener('click', () => COS.deschide());
  $('#drawerClose')?.addEventListener('click', () => COS.inchide());
  $('#drawerBg')?.addEventListener('click', () => COS.inchide());
  addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('open')) COS.inchide(); });
  bindQty(drawer);
  // ștergere, schimbarea cantității și butoanele de adăugare din sertar
  drawer.addEventListener('click', e => {
    const rm = e.target.closest('[data-rm]');
    if (rm) { e.preventDefault(); COS.schimba(rm.dataset.rm, 0); return; }
    const add = e.target.closest('[data-adauga]');
    if (add) { e.preventDefault(); const inp = $('.qty input', add.closest('.xsa, .row') || add.parentElement); COS.adauga(add.dataset.adauga, parseInt(inp?.value) || parseInt(add.dataset.qty) || 1); return; }
    const pachet = e.target.closest('[data-pachet]');
    if (pachet) {
      e.preventDefault();
      $$('[data-pachet]', drawer).forEach(b => b.classList.toggle('on', b === pachet));
      const alege = $('#alegePachet', drawer); if (alege) alege.dataset.adauga = pachet.dataset.pachet;
      const pret = $('#pachetPret', drawer); if (pret && pachet.dataset.pret) pret.firstChild.textContent = pachet.dataset.pret;
    }
  });
  drawer.addEventListener('qty', e => {
    const rand = e.target.closest('.item'); if (!rand) return;
    COS.schimba(rand.dataset.key, parseInt($('input', e.target).value) || 1);
  });
}

/* butoanele „Adaugă în coș” din pagini */
function bindAdauga(root = document) {
  $$('form[data-cos]', root).forEach(f => {
    if (f.dataset.bound) return; f.dataset.bound = '1';
    f.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('[type="submit"]', f), text = btn?.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Se adaugă…'; }
      const id = $('[name="id"]', f)?.value, qty = parseInt($('[name="quantity"]', f)?.value) || 1;
      await COS.adauga(id, qty);
      if (btn) { btn.disabled = false; btn.textContent = text; }
    });
  });
}

/* ---------- banda de clipuri ---------- */
/* Poziția = progresul derulării paginii + deplasarea manuală a utilizatorului; pe telefon e derulare nativă. */
function initStrip(root) {
  if (!root || root.dataset.bound) return; root.dataset.bound = '1';
  let base = 0, userOff = 0, prog = false, raf = 0;
  const maxLeft = () => Math.max(0, root.scrollWidth - root.clientWidth);
  const apply = () => { prog = true; root.scrollLeft = Math.max(0, Math.min(maxLeft(), base + userOff)); requestAnimationFrame(() => { prog = false; }); };
  const update = () => { raf = 0; if (REDUCED || phone()) return; const r = root.getBoundingClientRect(); const start = innerHeight * .85, end = innerHeight * .1 - r.height; const p = Math.max(0, Math.min(1, (start - r.top) / (start - end))); base = p * maxLeft(); apply(); };
  const onScroll = () => { if (!raf && root.isConnected) raf = requestAnimationFrame(update); };
  addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); update();
  root.addEventListener('scroll', () => { if (!prog) userOff = root.scrollLeft - base; }, { passive: true });
  let drag = null;
  root.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; drag = { x: e.clientX, left: root.scrollLeft }; root.classList.add('dragging'); });
  root.addEventListener('pointermove', e => { if (!drag) return; root.scrollLeft = drag.left - (e.clientX - drag.x); });
  const endDrag = () => { drag = null; root.classList.remove('dragging'); };
  root.addEventListener('pointerup', endDrag); root.addEventListener('pointercancel', endDrag); root.addEventListener('pointerleave', endDrag);
}

/* ---------- panourile lumilor ---------- */
function initPanels(root) {
  if (!root || root.dataset.bound) return; root.dataset.bound = '1';
  const panels = $$('.panel', root); let i = 0, timer = null;
  const show = k => {
    i = k; panels.forEach((p, j) => { p.classList.toggle('on', j === k); const v = $('video', p); if (!v) return; if (j === k || phone()) { if (!v.src) { const s = videoSrc(v); if (s) v.src = s; } if (PLAYABLE) v.play().catch(() => {}); } else v.pause(); });
    clearTimeout(timer); if (PLAYABLE && !phone()) timer = setTimeout(() => show((i + 1) % panels.length), 5000);
  };
  panels.forEach((p, k) => {
    p.addEventListener('mouseenter', () => show(k)); p.addEventListener('focus', () => show(k));
    p.addEventListener('mousemove', e => { const r = p.getBoundingClientRect(); p.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5).toFixed(3)); p.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5).toFixed(3)); });
    p.addEventListener('mouseleave', () => { p.style.setProperty('--mx', 0); p.style.setProperty('--my', 0); });
  });
  new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) show(i); else { clearTimeout(timer); panels.forEach(p => $('video', p)?.pause()); } }), { threshold: .3 }).observe(root);
}

/* ---------- calculatorul de profit ---------- */
function fmtLei(n) {
  const neg = n < 0; n = Math.abs(n);
  const [whole, frac] = (Number.isInteger(n) ? String(n) : n.toFixed(2)).split('.');
  return `${neg ? '−' : ''}${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${frac ? ',' + frac : ''} lei`;
}
function fmtPayback(luni) {
  if (!isFinite(luni)) return '—';
  if (luni < 1) return `${Math.max(1, Math.ceil(luni * 30))} zile`;
  return `${luni.toFixed(1).replace('.', ',')} luni`;
}
function bindCalc(root) {
  if (!root || root.dataset.bound) return; root.dataset.bound = '1';
  const pretAparat = parseFloat(root.dataset.aparat) || 4550;
  const q = k => root.querySelector(`[name="${k}"]`);
  const out = () => {
    const v = {}; ['perDay', 'price', 'content', 'can', 'days'].forEach(k => { v[k] = parseFloat(q(k)?.value) || 0; });
    const venit = v.perDay * v.price * v.days, cost = v.perDay * (v.content + v.can) * v.days, profit = venit - cost;
    const set = (k, val) => { const el = root.querySelector(`[data-out="${k}"]`); if (el) el.textContent = val; };
    set('revenue', fmtLei(Math.round(venit))); set('cost', fmtLei(Math.round(cost))); set('profit', fmtLei(Math.round(profit)));
    set('payback', fmtPayback(profit > 0 ? pretAparat / profit : Infinity));
    set('perMonth', String(Math.round(v.perDay * v.days)));
  };
  $$('input', root).forEach(i => i.addEventListener('input', out));
  out();
}

/* ---------- clipurile de pe Instagram ---------- */
function bindReels() {
  const lb = $('#lb'), lbV = $('#lbVideo'); if (!lb) return;
  const inchide = () => { lbV.pause(); lbV.removeAttribute('src'); lbV.load(); lb.hidden = true; document.body.classList.remove('lock'); };
  document.addEventListener('click', e => {
    const a = e.target.closest('a.reel'); if (!a) return;
    const clip = a.dataset.clip;
    if (!clip) return; // fără clip local, se deschide postarea
    e.preventDefault();
    $('#lbCap').textContent = a.dataset.cap || '';
    $('#lbIg').href = a.href;
    lbV.onerror = () => { inchide(); window.open(a.href, '_blank', 'noopener'); };
    lbV.src = clip; lb.hidden = false; document.body.classList.add('lock');
    lbV.play().catch(() => {});
  });
  $('#lbBg').onclick = inchide; $('#lbClose').onclick = inchide;
  addEventListener('keydown', e => { if (e.key === 'Escape' && !lb.hidden) inchide(); });
}

/* ---------- antet, meniu, butonul de WhatsApp ---------- */
function bindGlobal() {
  const nav = $('#nav'), burger = $('#burger');
  burger?.addEventListener('click', () => { const o = nav.classList.toggle('open'); burger.setAttribute('aria-expanded', String(o)); document.body.classList.toggle('menu-open', o); });
  addEventListener('scroll', () => nav?.classList.toggle('scrolled', scrollY > 8), { passive: true });

  const fab = $('#waFab'), footBar = $('.foot .bar');
  if (fab) {
    let raf = 0;
    const show = () => { raf = 0; const scurta = document.documentElement.scrollHeight - innerHeight < 320; fab.classList.toggle('on', scurta || scrollY > innerHeight * .55); };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(show); }, { passive: true });
    addEventListener('resize', show); setTimeout(show, 300);
    if (footBar && 'IntersectionObserver' in window) new IntersectionObserver(es => es.forEach(e => fab.classList.toggle('away', e.isIntersecting))).observe(footBar);
  }
}

/* ---------- pornire ---------- */
/* ---------- numerele din banda de dovezi urcă o dată, când intră în ecran ---------- */
function urcaCifra(b) {
  const brut = b.dataset.cifra || b.textContent.trim();
  const m = brut.match(/\d[\d.]*\d|\d+/);
  if (!m) return;
  const tinta = parseInt(m[0].replace(/\D/g, ''), 10);
  if (!isFinite(tinta) || tinta < 10) return;
  const cuPunct = m[0].includes('.');
  const inainte = brut.slice(0, m.index), dupa = brut.slice(m.index + m[0].length);
  const durata = 1100, t0 = performance.now();
  const scrie = v => { b.textContent = inainte + (cuPunct ? v.toLocaleString('ro-RO') : String(v)) + dupa; };
  scrie(0);
  const pas = acum => {
    const p = Math.min(1, (acum - t0) / durata);
    scrie(Math.round(tinta * (1 - Math.pow(1 - p, 3))));
    if (p < 1) requestAnimationFrame(pas); else b.textContent = brut;
  };
  requestAnimationFrame(pas);
}
const cifraIO = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
  if (e.isIntersecting) { cifraIO.unobserve(e.target); urcaCifra(e.target); }
}), { threshold: .45 }) : null;
function initCifre(root = document) {
  if (REDUCED || !cifraIO) return;
  $$('.sec.banda .stats b', root).forEach(b => {
    if (b.dataset.cifra) return;
    b.dataset.cifra = b.textContent.trim();
    cifraIO.observe(b);
  });
}

function initSectiune(root = document) {
  observeReveals(root); playInView(root); bindQty(root); bindAdauga(root); initGallery(root);
  initCifre(root);
  $$(SWIPE_ROWS, root).forEach(initSwipe);
  $$('.strip', root).forEach(initStrip);
  $$('.panels', root).forEach(initPanels);
  $$('.calc', root).forEach(bindCalc);
  // clipurile care nu sunt lăsate în seama observatorului pornesc direct
  $$('video[autoplay]', root).forEach(v => { if (PLAYABLE) v.play().catch(() => {}); });
}
initSectiune();
bindCos();
bindReels();
bindGlobal();

/* Theme Editor: secțiunile se reîncarcă singure. */
document.addEventListener('shopify:section:load', e => initSectiune(e.target));
document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('#drawer')) COS.deschide(); });


/* ---------- cookie-uri ---------- */
/* Alegerea se scrie prin API-ul de consimțământ al Shopify, care o duce mai departe la pixeli și la Google,
   în modul de consimțământ v2. Bannerul apare doar unde Shopify spune că e nevoie de el. */
function bindCookie() {
  const el = $('#cookie'); if (!el) return;
  const prefs = $('#cookiePrefs', el);
  const salveaza = $('[data-cookie="salveaza"]', el);
  const arata = () => { el.hidden = false; document.body.classList.add('cookie-open'); };
  const ascunde = () => { el.hidden = true; document.body.classList.remove('cookie-open'); };

  const cuApi = gata => {
    if (window.Shopify?.customerPrivacy) return gata(window.Shopify.customerPrivacy);
    if (!window.Shopify?.loadFeatures) return;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], eroare => {
      if (!eroare && window.Shopify.customerPrivacy) gata(window.Shopify.customerPrivacy);
    });
  };

  cuApi(cp => {
    const curent = () => { try { return cp.currentVisitorConsent() || {}; } catch { return {}; } };
    const pune = (valori, dupa) => {
      try { cp.setTrackingConsent(valori, () => { ascunde(); if (dupa) dupa(); }); }
      catch { ascunde(); }
    };
    const deschidePrefs = () => {
      const c = curent();
      $$('[data-consimt]', prefs).forEach(i => { i.checked = c[i.dataset.consimt] === 'yes'; });
      prefs.hidden = false;
      salveaza.hidden = false;
      $('[data-cookie="prefs"]', el).hidden = true;
      arata();
    };

    try { if (cp.shouldShowBanner()) arata(); } catch {}

    el.addEventListener('click', e => {
      const b = e.target.closest('[data-cookie]'); if (!b) return;
      const ce = b.dataset.cookie;
      if (ce === 'tot') pune({ analytics: true, marketing: true, preferences: true, sale_of_data: true });
      else if (ce === 'refuz') pune({ analytics: false, marketing: false, preferences: false, sale_of_data: false });
      else if (ce === 'prefs') deschidePrefs();
      else if (ce === 'salveaza') {
        const v = {};
        $$('[data-consimt]', prefs).forEach(i => { v[i.dataset.consimt] = i.checked; });
        v.sale_of_data = !!v.marketing;
        pune(v);
      }
    });

    // legătura din subsol redeschide fereastra cu alegerile de acum
    document.addEventListener('click', e => {
      const a = e.target.closest('[href="#cookie-preferinte"], [data-cookie-deschide]');
      if (!a) return;
      e.preventDefault();
      deschidePrefs();
    });
  });
}
bindCookie();


/* „Preferințe cookie" din subsol: deschide bannerul temei dacă e pornit, altfel preferințele bannerului Shopify. */
document.addEventListener('click', e => {
  const a = e.target.closest('[data-cookie-deschide], a[href="#cookie-preferinte"]');
  if (!a || $('#cookie')) return;
  e.preventDefault();
  if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
  else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => window.privacyBanner?.showPreferences?.());
});
